import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {ProposalTile} from '../../../model/proposal-tile';
import {Proposal} from '../../../model/proposal/proposal';
import {Offer} from '../../../model/offer/offer';
import {ProposalFilterQuery} from '../../../model/proposal-filter-query';
import {User} from '../../../model/user';
import {ProposalNumber} from '../../../model/proposal-number';
import {PrivateNote} from '../../../model/offer/private-note';

export const ProposalTileActions = createActionGroup({
  source: 'Proposal API',
  events: {
    Load: emptyProps(),
    Loaded: props<{ proposalTiles: ProposalTile[] }>(),
    ErrorLoading: props<{ error: Error }>(),
    Reject: props<{ rejectionId: string, rejectionOffer: Offer }>(),
    Rejected: props<{ rejectionOffer: Offer }>(),
    ErrorRejecting: props<{ error: Error }>(),
    RetractRejection: props<{ rejectionId: string, proposalId: string }>(),
    RetractedRejection: emptyProps(),
    ErrorRetractingRejection: props<{ error: Error }>(),
    StartRejectionLoading: emptyProps(),
    StopRejectionLoading: emptyProps(),
    StartRetractRejectionLoading: emptyProps(),
    StopRetractRejectionLoading: emptyProps(),
  }
});

export const ProposalOverview = createActionGroup({
  source: 'ProposalFilter API',
  events: {
    updateFilter: props<{ filter: Partial<ProposalFilterQuery> }>(),
    resetPagination: emptyProps()
  }
});

export const ProposalTransmissionActions = createActionGroup({
  source: 'ProposalTransmission API',
  events: {
    load: props<{ id: string, secret: string }>(),
    loaded: props<{ proposal: Proposal }>(),
    errorLoading: props<{ error: Error }>(),
  }
});

export const ProposalSelectedActions = createActionGroup({
  source: 'ProposalSelected API',
  events: {
    Load: props<{ proposalId: string }>(),
    Loaded: props<{ proposalSelected: Proposal }>(),
    Deselect: emptyProps(),
    ErrorLoading: props<{ error: Error }>(),
    LoadedOffers: props<{ proposalSelectedOffers: Offer[] }>(),
    loadedUserAllowedToView: props<{ usersAllowedToView: User[] }>()
  }
});

export const ProposalDetailPageActions = createActionGroup({
  source: 'DetailPage API',
  events: {
    load: props<{ proposalId: string }>(),
    loadedProposalTile: props<{ proposalTile: ProposalTile }>(),
    loadedProposal: props<{ proposal: Proposal }>(),
    openAll: emptyProps(),
    closeAll: emptyProps(),
    loadedOffers: props<{ offers: Offer[] }>(),
    selectOffer: props<{ offer: Offer }>(),
    ErrorLoading: props<{ error: Error }>(),
    acceptOffer: props<{ offerId: string, includeCompanyName?: boolean,  includeCoverage?: boolean, includeClausesAndConditions?: boolean, includePremium?: boolean, proposalId?: string}>(),
    retractOffer: props<{ offerId: string, proposalId: string }>(),
    proposalPreview: props<{ proposalPreview: Proposal, proposalTilePreview: ProposalTile, maxScrolled: number, isFormDirty: boolean }>(),
    resetPreview: emptyProps(),
    loadPrivateNotes: props<{ userId: string, proposalId: string }>(),
    loadedPrivateNotes: props<{ privateNotes: PrivateNote[] }>()
  }
});

export const ProposalNumberActions = createActionGroup({
  source: 'ProposalNumber API',
  events: {
    LoadProposalNumber: emptyProps(),
    ProposalNumberLoaded: props<{ proposalNumber: ProposalNumber }>(),
    ProposalNumberError: props<{ error: any }>(),
  }
});





